import { useState } from 'react';
import { useBangKePhieuXuatTraNCCContext } from '../context';
import { initialValues, SearchFormValues } from '../schema';

export const useDialogState = () => {
  const [initialSearchDialogOpen, setInitialSearchDialogOpen] = useState(true);
  const [editPrintTemplateDialogOpen, setEditPrintTemplateDialogOpen] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [searchParams, setSearchParams] = useState<SearchFormValues>(initialValues);
  const { setQueryParams, exportToExcel } = useBangKePhieuXuatTraNCCContext();
  const handleInitialSearch = async (
    formData: SearchFormValues,
    getReport: (params: MuaHangRecord) => Promise<void>
  ) => {
    try {
      await getReport(formData);
      setSearchParams(formData);
      setQueryParams(formData);
      setInitialSearchDialogOpen(false);
      setShowTable(true);
      handleInitialSearchClose();
    } catch (e) {
      return;
    }
  };

  const handleRefreshClick = async (getReport: (params: MuaHangRecord) => Promise<void>) => {
    if (searchParams) {
      await getReport(searchParams);
    }
  };

  const handleInitialSearchClose = () => {
    setInitialSearchDialogOpen(false);
  };

  const handleSearchClick = () => {
    setInitialSearchDialogOpen(true);
  };

  const handleEditPrintTemplateClick = () => {
    setEditPrintTemplateDialogOpen(true);
  };

  const handleClosePrintTemplateDialog = () => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleSavePrintTemplate = (_template: MuaHangRecord) => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleRowClick = (_row: MuaHangRecord) => {};

  const handleFixedColumnsClick = () => {};

  const handleExportDataClick = () => exportToExcel();

  return {
    // State
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,

    // Handlers
    handleInitialSearch,
    handleRefreshClick,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleRowClick,
    handleFixedColumnsClick,
    handleExportDataClick
  };
};
